import { colors, fontWeight, typography } from './themeTokens'

export { colors, fontWeight, typography }

export type ColorScale = Record<string, string>

export function getColor(
	name: keyof typeof colors,
	shade?: string
): string | undefined {
	const value = colors[name]
	if (typeof value === 'string') {
		return value
	}
	if (typeof value === 'object' && shade) {
		return (value as ColorScale)[shade]
	}
	return undefined
}
